import React, { useState, useRef, useEffect } from 'react';
import plus from '../../../../assets/Imagess/plusvector.svg';
import Buttons from '../../../Atoms/Buttons/Buttons';
import { useNavigate } from 'react-router-dom';
import { useUploadBulk } from '../../../../Hooks/Externalcontact';
import { toast } from 'react-toastify';
import styles from './ContactButton.module.scss';
import { IconWrapper } from '../../../Atoms/icons/Icon';
const ContactButton = ({ refetch }) => {
  const inputRef = useRef();
  const navigate = useNavigate();
  const dropdownRef = useRef(null);

  const [open, setOpen] = useState(false);
  const { mutate: uploadBulk, isLoading } = useUploadBulk();

  const handleButtonClick = () => setOpen(!open);
  const handleUploadClick = () => {
    inputRef.current.click();
  };
  const handleFilesChange = (e) => {
    const files = e.target.files;
    const formdata = new FormData();
    formdata.append('file', files[0]);
    uploadBulk(formdata, {
      onSuccess: () => {
        toast.success('Uploaded successfully');
        setOpen(false);
        refetch();
      },
      onError: (error) => {
        toast.error(error?.response?.data?.message);
      },
    });

    e.target.value = null;
  };
  const handleDownloadTemp = () => {
    const link = document.createElement('a');
    link.href = '/doc/ExternalContacts_Filled_Sample.xlsx';
    link.download = 'ExternalContacts_Filled_Sample.xlsx';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setOpen(false);
  };
  const options = [
    {
      label: 'Create New Contact',
      onClick: () => navigate('/home/add-externalContact'),
      icon: 'plus',
    },
    {
      label: 'Upload Bulk Contact',
      onClick: () => handleUploadClick(),
      icon: 'upload',
      isLoading: isLoading,
    },
    {
      label: 'Download Bulk Contact Template',
      onClick: () => handleDownloadTemp(),
      icon: 'download',
    },
  ];

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className={styles.contactDropdown} ref={dropdownRef}>
      <Buttons
        text='External Contact'
        icon={plus}
        rounded={true}
        color='#F3223C'
        handleOnClick={handleButtonClick}
      />

      {open && (
        <div className={styles.dropdown}>
          {options?.map((i) => (
            <div
              onClick={i.onClick}
              className={i.isLoading ? styles.loading : ''}
            >
              {i.isLoading ? (
                <div className={styles['loaderX']}></div>
              ) : (
                <IconWrapper icon={i.icon} className={styles.icon} />
              )}
              <p>{i.label}</p>
            </div>
          ))}
          <input
            type='file'
            ref={inputRef}
            style={{ display: 'none' }}
            onChange={handleFilesChange}
          />
        </div>
      )}
    </div>
  );
};

export default ContactButton;
